import React from "react";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";
import {ManageServicesTable} from "../../UI/Main/ManageServicesTable";

const ManageServices = () => {
    return (
        <div>
            <PanelHead title="Manage Services" />
            <PanelBody content={<ManageServicesTable />} />
        </div>
    );
};

export default ManageServices;
